// font file
import { NextFontWithVariable } from 'next/dist/compiled/@next/font';
import { Almarai } from 'next/font/google';

const almarai = Almarai({
  preload: true,
  subsets: ['arabic'],
  weight: ['300', '400', '700', '800'],
  display: 'swap',
  variable: '--font-almarai',
});

const fonts = [almarai] as NextFontWithVariable[];

export default fonts;
